import { render, staticRenderFns } from "./project.vue?vue&type=template&id=0f9d6009"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9d6009')) {
      api.createRecord('0f9d6009', component.options)
    } else {
      api.reload('0f9d6009', component.options)
    }
    module.hot.accept("./project.vue?vue&type=template&id=0f9d6009", function () {
      api.rerender('0f9d6009', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/project.vue"
export default component.exports